import { useState } from 'react';

type Params = {
  applicationId: string;
  openVideoModal: () => void;
};

export const useViewVideoScreening = ({
  applicationId: _applicationId,
  openVideoModal
}: Params) => {
  const [isVideoViewed, setVideoViewed] = useState(false);

  const onViewVideoScreeningPress = () => {
    setVideoViewed(true);
    openVideoModal();
  };

  return {
    onViewVideoScreeningPress,
    errorMessage: '',
    isVideoViewed
  };
};
